export const ALERT_I18N_MESSAGES = {
  'en-US': {
    A1001: 'Planned Server Maintenance',
    A1002:
      'On March 17th 23:30 PDT, our servers will undergo scheduled service. Uploads and app access may be limited, but we’ll be back in a few hours!',
    A1003: 'More Info',
    A1004:'Planned Server Maintenance In-Progress',
    A1005:`We're currently performing some routine maintenance on our servers for the next few hours. You may be unable to upload workouts or access data on the COROS app and Training Hub during this time. `
  },
  'zh-CN': {
    A1001: 'Planned Server Maintenance',
    A1002:
      'On March 17th 23:30 PDT, our servers will undergo scheduled service. Uploads and app access may be limited, but we’ll be back in a few hours!',
    A1003: 'More Info',
    A1004:'Planned Server Maintenance In-Progress',
    A1005:`We're currently performing some routine maintenance on our servers for the next few hours. You may be unable to upload workouts or access data on the COROS app and Training Hub during this time. `
  },
  'es-ES': {
    A1001: 'Mantenimiento planificado del servidor',
    A1002:
      'El 18 de marzo a las 06:30 CET, nuestros servidores se someterán a una rápida puesta a punto. Las cargas y el acceso a la aplicación pueden verse limitados, ¡pero volveremos en unas horas!',
    A1003: 'Más información',
    A1004:'Mantenimiento planificado del servidor En curso',
    A1005:`Actualmente estamos realizando un mantenimiento rutinario de nuestros servidores durante las próximas horas. Es posible que no pueda cargar entrenamientos ni acceder a datos en la aplicación COROS y en Training Hub durante este tiempo.`
  },
  'fr-FR': {
    A1001: 'Maintenance des serveurs',
    A1002: `Le 18 mars à 6h30, nos serveurs subiront une rapide mise à jour. Les téléchargements et l'accès aux applications peuvent être limités, mais nous serons de retour dans quelques heures !`,
    A1003: 'En savoir plus',
    A1004:'Maintenance planifiée des serveurs en cours',
    A1005:`Nous effectuons une maintenance de routine sur nos serveurs pendant les prochaines heures. Il se peut que vous ne puissiez pas télécharger d'entraînements ou accéder aux données sur l'application COROS et Training Hub pendant ce temps.`
  },
  'de-DE': {
    A1001: 'Geplante Wartung der Server',
    A1002: `Am 18. März um 06:30 Uhr MEZ werden unsere Server einer kurzen Wartung unterzogen. Downloads und der Zugriff auf Anwendungen können eingeschränkt sein, aber wir sind in wenigen Stunden wieder da!`,
    A1003: 'Weitere Informationen',
    A1004:'Geplante Serverwartung wird durchgeführt',
    A1005:`Wir führen derzeit für die nächsten Stunden einige routinemäßige Wartungsarbeiten an unseren Servern durch. Während dieser Zeit können Sie möglicherweise keine Trainingseinheiten hochladen oder auf Daten in der COROS-App und im Training Hub zugreifen.`
  },
  'ja-JP': {
    A1001: 'システムメンテナンスのお知らせ',
    A1002: '平素はCOROSデバイス、アプリ等をご利用いただき、誠にありがとうございます。下記日程にて、システムメンテナンスを実施致します。',
    A1003: '詳細確認',
    A1004:'システムメンテナンスのお知らせ',
    A1005:`平素はCOROSデバイス、アプリ等をご利用いただき、誠にありがとうございます。下記日程にて、システムメンテナンスを実施致します。 `
  }
};
export const ALERT_MORE_LINKS={
  'en-US':'https://support.coros.com/hc/en-us/articles/360042534572-COROS-Status',
  'es-ES':'https://support.coros.com/hc/es/articles/360042534572-Estado-de-COROS',
  'fr-FR': 'https://support.coros.com/hc/fr/articles/360042534572-Statut-COROS',
  'de-DE':'https://support.coros.com/hc/de/articles/360042534572-COROS-Status',
  'ja-JP': 'https://jp.coros.com/stories/others/c/Notice-of-System-Maintenance'
}
export const ALERT_TIME={
  start:1742276700,
  end:1742286600
}
